import { IGcfComponentConfig } from 'src/interfaces';

import {
  GcfCommonComponentConfigSchema,
  GcfHeaderSchema,
  GcfShelfStyleInterface,
  IFlexDyHeader,
} from '../FormSelector.interface';

export enum DyProductSource {
  DYS = 'DYS',
  DYR = 'DYR',
}

export interface IMobileOrderPay {
  background: string;
}

export interface ISingleShelfConfig extends IGcfComponentConfig {
  lineupStyle?: GcfShelfStyleInterface;
  productsSource?: DyProductSource;
  mop?: IMobileOrderPay;
  knownCustomer?: IFlexDyHeader;
  unknownCustomer?: IFlexDyHeader;
}

export const SingleShelfConfigSchema = {
  title: 'Shelf Component JSON Config',
  description:
    'JSON Configuration Options for GCF Shelf Component (Single & Double)',
  type: 'object',
  properties: {
    ...GcfCommonComponentConfigSchema.properties,
    lineupStyle: {
      type: 'object',
      properties: {
        type: {
          type: 'string',
          enum: ['STAGGERED', 'STRAIGHT'],
        },
        textAlignment: {
          type: 'string',
          enum: ['LEFT', 'CENTER', 'RIGHT'],
        },
        pattern: {
          type: 'string',
          enum: ['', 'FROM_TOP', 'FROM_BOTTOM'],
        },
        order: {
          type: 'string',
          enum: ['DEFAULT', 'IMAGE_BELOW_TEXT'],
        },
        padding: {
          type: 'number',
        },
      },
      required: ['type'],
      additionalProperties: false,
    },
    mop: {
      type: 'object',
      properties: {
        background: {
          type: 'string',
          minLength: 1,
        },
      },
      required: ['background'],
    },
    knownCustomer: {
      type: 'object',
      properties: {
        header: GcfHeaderSchema,
      },
    },
    unknownCustomer: {
      type: 'object',
      properties: {
        header: GcfHeaderSchema,
      },
    },
  },
  required: [...GcfCommonComponentConfigSchema.required, 'mop'],
  additionalProperties: true,
};
